












import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  辅助标题
 * @desc 辅助标题
 */
@Component
export default class SubtitleExample extends Vue {
}
